export default "__VITE_ASSET__DmJAgq$v__"